<div class="table-wrapper-smaller">
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th class="icon"></th>
          <th class="string sortable" id="royaltiesGestEtiqCol2" [appSort]="_royaltiesEtiquetador" data-order="desc" data-name="desPais" (click)="toOrderBy(2)">{{'global.pais' | translate}}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(2)"></i>
            </div>
          </th>
          <th class="string sortable sortable-biggest" id="royaltiesGestEtiqCol3" [appSort]="_royaltiesEtiquetador" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(3)">{{'gestionRoyalties.etiquetador.table.etiquetador' | translate}}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(3)"></i>
            </div>
          </th>
          <th class="string sortable" id="royaltiesGestEtiqCol4" [appSort]="_royaltiesEtiquetador" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(4)">{{'gestionRoyalties.etiquetador.table.denominacion' | translate}}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(4)"></i>
            </div>
          </th>
          <th class="string sortable" id="royaltiesGestEtiqCol5" [appSort]="_royaltiesEtiquetador" data-order="desc" data-name="desMarca" (click)="toOrderBy(5)">{{'gestionRoyalties.etiquetador.table.marca' | translate}}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(5)"></i>
            </div>
          </th>
          <th class="number sortable" id="royaltiesGestEtiqCol6" [appSort]="_royaltiesEtiquetador" data-order="desc" data-name="sumaKilos" (click)="toOrderBy(6)">{{'gestionRoyalties.etiquetador.table.pesoEtiquetado' | translate}} {{ _unidadesMedida ? "(" +_unidadesMedida.peso.symbol + ")" : "" }}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(6)"></i>
            </div>
          </th>
          <th class="number sortable" id="royaltiesGestEtiqCol7" [appSort]="_royaltiesEtiquetador" data-order="desc" data-name="calculo_Kilos_Fee" (click)="toOrderBy(7)">{{'gestionRoyalties.etiquetador.table.importe' | translate}} {{ _unidadesMedida ? "(" +_unidadesMedida.divisas.symbol + ")" : "" }}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(7)"></i>
            </div>
          </th>
          <th class="number sortable" id="royaltiesGestEtiqCol8" [appSort]="_royaltiesEtiquetador" data-order="desc" data-name="total_Fee" (click)="toOrderBy(8)">{{'gestionRoyalties.etiquetador.table.total' | translate}} {{ _unidadesMedida ? "(" +_unidadesMedida.divisas.symbol + ")" : "" }}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(8)"></i>
            </div>
          </th>
          <th class="multi-actions"></th>
        </tr>
      </thead>
      <tbody *ngFor="let royalty of royalties; let i = index; trackBy: trackByEtiquetadorId">
        <tr [ngClass]="{'dropdownInfo': dropdownInfo === i}" (click)="showDetails(i)" style="cursor: pointer;">
          <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
            title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
          </td>
          <td class="string">{{royalty.desPais}}</td>
          <td class="string-longest">{{royalty.desEtiquetador}}</td>
          <td class="string">{{royalty.desDenominacion}}</td>
          <td class="string">{{royalty.desMarca}}</td>
          <td class="number">{{(royalty.sumaKilos | number : '1.2-2' : defaultLanguage)}}</td>
          <td class="number">{{(royalty.calculo_Kilos_Fee | number : '1.2-2' : defaultLanguage)}}</td>
          <td class="number">{{(royalty.total_Fee | number : '1.2-2' : defaultLanguage)}}</td>
          <td class="multi-actions">
            <i class="fas fa-stream" app-click-stop-propagation (click)="openTabs(i)" title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
            <i class="fas fa-file-pdf" (click)="exportPdf(i)" title="{{'gestionRoyalties.etiquetador.exportPDF' | translate}}"></i>
          </td>
        </tr>
        <tr *ngIf="dropdownInfo === i">
          <td colspan="9">
            <div class="detail">
              <div class="title">{{'global.masInformacion' | translate}}</div>
              <div class="block-inline">
                <label>{{'gestionRoyalties.etiquetador.table.royalty' | translate}} {{'gestionRoyalties.etiquetador.table.pesoEtiquetado' | translate}}</label>
                <p>{{royalty.royalty_Kilos_Fee | number : '1.2-2' : defaultLanguage}} {{ _unidadesMedida.divisas.symbol }}</p>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="dropdownSection === i">
          <td colspan="9">
              <section class="tabs">
                  <ul>
                      <li class="active">{{'global.cultivos' | translate}}</li>
                  </ul>
                  <content>
                      <app-roy-cultivos-etiquetador [cultivos]="cultivosEtiquetador" [unidadesMedida]="_unidadesMedida"></app-roy-cultivos-etiquetador>
                  </content>
              </section>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="!royalties || (royalties && royalties.length < 1) || _filterProdApplied">
        <tr *ngIf="!royalties && !_filterProdApplied || (royalties && royalties.length < 1 && !_filterProdApplied)">
            <td colspan="9">
                {{'global.noContent' | translate}}
            </td>
        </tr>
        <tr *ngIf="_filterProdApplied">
          <td colspan="13">
            {{'gestionRoyalties.etiquetador.filterProdApplied' | translate}}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
<app-paginator
        *ngIf="(_royaltiesEtiquetador && _royaltiesEtiquetador.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
